type LogoProps = {
  size?: number;
  withWordmark?: boolean;
  wordmarkClassName?: string;
  className?: string;
};

export default function Logo({
  size = 32,
  withWordmark = false,
  wordmarkClassName = "font-display text-xl md:text-2xl font-bold tracking-tight",
  className = "",
}: LogoProps) {
  const mark = (
    <img
      src="/brand/logo.png"
      alt="BajApp Xperiences"
      width={size}
      height={size}
      className={className}
      draggable={false}
      style={{ objectFit: "contain" }}
    />
  );

  if (!withWordmark) return mark;

  return (
    <span className="flex items-center gap-2 shrink-0">
      {mark}
      <span className={wordmarkClassName}>BajApp Xperiences</span>
    </span>
  );
}
